// extracted by mini-css-extract-plugin
export var project = "styles-module--project--3iAHG";
export var Title = "styles-module--Title--2v5_k";
export var Techs = "styles-module--Techs--3Vmbc";